import jsonShippings from '@/assets/shippings.json';
import jsonCountries from '@/assets/countries.json';
import {helper} from '@/mixins/helper.js'
export const shopBase = {
    mixins:[helper],
    data(){
        return {
          shipping:jsonShippings,
          countries:jsonCountries,
          SHIP_INTERNATIONAL:5
        }
    },
    computed:{

    },
    methods: {
        isEmpty(row,attr){
          if(row && row[attr]){
            return (row[attr]==null || row[attr]=="")
          }
          return true;
        },
        getShopById(dataset,id){
            let res=null;
            if(dataset){
              res= this._.find(dataset,(shop)=>{
                return shop.id==id || this.removeSpecialCharsFromString(shop.title)==id
              });
            }
            return res;
        },
        hasCategory(row){
          return (row && !this._.isEmpty(row.category))
        },
        hasContact(row){
          return (!this.isEmpty(row,'name') || !this.isEmpty(row,'nr') || !this.isEmpty(row,'tel') || !this.isEmpty(row,'email') )
        },
        
        hasShippingText(row){
          return !this.isEmpty(row,'shipText');
        },
        getTablerContact(row){
            let res=[];
            if(row){
              //Name
              if(!this.isEmpty(row,'name')){
                res.push(row.name);
              }
              //Nr
              if(!this.isEmpty(row,'nr')){
                  res.push(row.nr);
                  //Country
                  if(!this.isEmpty(row,'country')){
                    res.push(this.getCountryAsString(row));
                  }
              }

            }
      
            return this._.isEmpty(res)?"":res.join(' | ');
          },
          getTablerExtendedContact(shop){
            let res=[];
            
            if(shop){
              if(!this.isEmpty(shop,'email') ){
                res.push('<a href="mailto:'+shop.email+'">'+shop.email+'</a>');
              }
              if(!this.isEmpty(shop,'tel') ){
                res.push('<a href="tel:'+shop.tel+'">'+shop.tel+'</a>');
              }
            }
            return this._.isEmpty(res)?"":res.join(' | ');
          },

          getImageStyle(shop){
            return (shop)?{
              'background': 'url('+encodeURI(shop.img)+')'
            }:'';
          },
          getShippingAsString(shop){
            if(shop){
              let shippments=this._.includes(shop.ship, this.SHIP_INTERNATIONAL)?[this.SHIP_INTERNATIONAL]:shop.ship;
              return this.getArrayAsString(this.shipping,shippments);
            }
            return "";
          },
          hasPosition(row){
            return !this.isEmpty(row,'lat') && !this.isEmpty(row,'lng')
          },
          getCountryAsString(shop){
            if(shop){
              let country=(shop.country)?shop.country:1;
              return this.getArrayAsString(this.countries,[country]);
            }
            return "";
          },
    }
}